import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "deals__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "main-list all-disputes__list"
}
const _hoisted_3 = { class: "main-item all-deals__item deal deal__not_found" }
const _hoisted_4 = {
  key: 1,
  class: "deals__container"
}
const _hoisted_5 = { style: {"overflow":"auto"} }
const _hoisted_6 = {
  class: "table table__flex",
  style: {"position":"relative"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-start p" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-start p" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-start p" }
const _hoisted_13 = { class: "text-capitalize-first" }
const _hoisted_14 = { class: "text-start p" }
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = {
  class: "text-start p",
  style: {"width":"0"}
}
const _hoisted_17 = { class: "text-capitalize-first" }
const _hoisted_18 = { class: "text-start p" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "pt pb ps flex-1" }
const _hoisted_21 = { class: "d-flex align-items-center gap-sm" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "d-flex flex-column" }
const _hoisted_24 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_25 = { class: "reception__number" }
const _hoisted_26 = { class: "text-secondary" }
const _hoisted_27 = { class: "pt pb flex-1 justify-content-end" }
const _hoisted_28 = { class: "d-flex flex-column sm-align-items-end" }
const _hoisted_29 = { class: "payment__info payment__info--status" }
const _hoisted_30 = { class: "payment__status" }
const _hoisted_31 = { class: "text-capitalize-first status-text no-wrap" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { class: "text-lowercase" }
const _hoisted_36 = {
  key: 2,
  class: "text-lowercase text-danger"
}
const _hoisted_37 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_38 = { class: "text-secondary" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "text-secondary" }
const _hoisted_41 = { class: "pt pb" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 1,
  class: "reception__rate rate-info"
}
const _hoisted_44 = { class: "rate-info__mobile-label" }
const _hoisted_45 = { class: "text-capitalize-first" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "pt pb" }
const _hoisted_49 = { class: "rate-info__mobile-label" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "reception__sums" }
const _hoisted_52 = {
  key: 0,
  class: "reception__sum-rub sum-info__rub"
}
const _hoisted_53 = { class: "d-flex align-items-center gap-xs no-wrap" }
const _hoisted_54 = { class: "d-flex align-items-center gap-xs no-wrap" }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = {
  key: 3,
  class: "reception__sum-currency sum-info__currency"
}
const _hoisted_57 = { class: "d-flex align-items-center gap-xs no-wrap" }
const _hoisted_58 = { key: 4 }
const _hoisted_59 = { class: "d-flex align-items-center gap-xs no-wrap" }
const _hoisted_60 = { key: 6 }
const _hoisted_61 = {
  key: 7,
  class: "reception__sum-rub sum-info__rub mt-1"
}
const _hoisted_62 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_63 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_64 = { key: 8 }
const _hoisted_65 = {
  key: 9,
  class: "reception__sum-currency sum-info__currency mt-1"
}
const _hoisted_66 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_67 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_68 = {
  key: 10,
  class: "payment__restriction"
}
const _hoisted_69 = {
  key: 11,
  class: "small text-secondary"
}
const _hoisted_70 = { class: "pt pb" }
const _hoisted_71 = {
  key: 0,
  class: "reception__sum sum-info"
}
const _hoisted_72 = { class: "rate-info__mobile-label" }
const _hoisted_73 = { class: "text-capitalize-first" }
const _hoisted_74 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "pt pb" }
const _hoisted_77 = { class: "reception__card card-info" }
const _hoisted_78 = { class: "d-flex align-items-center gap-sm" }
const _hoisted_79 = { class: "" }
const _hoisted_80 = { class: "card-info__title" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { class: "card-info__number" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "text-secondary text-wrap" }
const _hoisted_86 = {
  key: 4,
  class: "text-secondary text-wrap"
}
const _hoisted_87 = ["href"]
const _hoisted_88 = ["href"]
const _hoisted_89 = ["href"]
const _hoisted_90 = {
  key: 8,
  class: "d-flex align-items-center gap-xs"
}
const _hoisted_91 = ["href"]
const _hoisted_92 = {
  key: 9,
  class: "d-flex align-items-center gap-xs"
}
const _hoisted_93 = {
  key: 10,
  class: "d-flex align-items-center gap-xs"
}
const _hoisted_94 = { class: "card-info__name" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "pt pb pe" }
const _hoisted_97 = {
  key: 0,
  class: "payment__controls"
}
const _hoisted_98 = ["onClick"]
const _hoisted_99 = ["onClick"]
const _hoisted_100 = ["onClick"]
const _hoisted_101 = { class: "text-capitalize-first" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "text-capitalize-first" }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = ["onClick", "disabled", "title"]
const _hoisted_106 = { class: "text-capitalize-first" }
const _hoisted_107 = {
  key: 1,
  class: "payment__controls"
}
const _hoisted_108 = ["onClick"]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = ["onClick", "disabled", "title"]
const _hoisted_111 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_PaymentTime = _resolveComponent("PaymentTime")!
  const _component_ReceiptCheckControl = _resolveComponent("ReceiptCheckControl")!
  const _component_ReceiptCheckStatus = _resolveComponent("ReceiptCheckStatus")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_PayoutQrBlock = _resolveComponent("PayoutQrBlock")!
  const _component_VietQrPaymentBlock = _resolveComponent("VietQrPaymentBlock")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_DealDetailsPopup = _resolveComponent("DealDetailsPopup")!
  const _component_CancelReasonPopup = _resolveComponent("CancelReasonPopup")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_ConfirmPayoutPopup = _resolveComponent("ConfirmPayoutPopup")!
  const _component_PayOutDealSlaPopup = _resolveComponent("PayOutDealSlaPopup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoaderContent, { ref: "loader" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.deals.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('labels.deals_not_found')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", _hoisted_6, [
                    (!_ctx.hideHeader)
                      ? (_openBlock(), _createElementBlock("thead", _hoisted_7, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_8, [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('labels.id_date')), 1)
                            ]),
                            _createElementVNode("th", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('labels.status')), 1)
                            ]),
                            _createElementVNode("th", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.rateHeader), 1)
                            ]),
                            _createElementVNode("th", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('labels.sum')), 1)
                            ]),
                            _createElementVNode("th", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('labels.device')), 1)
                            ]),
                            _createElementVNode("th", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('labels.requisites')), 1)
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("th", { class: "text-start p" }, null, -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deals.items, (deal) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                ([_ctx.DealStatus.NEW, _ctx.DealStatus.TRANSFER_CONFIRMED, _ctx.DealStatus.TRANSFER_WAITING].includes(deal.status))
                                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                                      key: 0,
                                      class: "main-icon payment__icon",
                                      icon: `deal-${deal.type}`
                                    }, null, 8, ["icon"]))
                                  : (deal.status === _ctx.DealStatus.COMPLETED)
                                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                                        key: 1,
                                        class: "main-icon payment__icon payment__icon__completed",
                                        icon: "deal-completed"
                                      }))
                                    : (deal.status === _ctx.DealStatus.DISPUTE)
                                      ? (_openBlock(), _createBlock(_component_SvgIcon, {
                                          key: 2,
                                          class: "main-icon payment__icon payment__icon__dispute",
                                          icon: "deal-dispute"
                                        }))
                                      : (deal.status === _ctx.DealStatus.CANCELED)
                                        ? (_openBlock(), _createBlock(_component_SvgIcon, {
                                            key: 3,
                                            class: "main-icon payment__icon payment__icon__canceled",
                                            icon: "deal-canceled"
                                          }))
                                        : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["badge", {'badge__warning': deal.type === _ctx.Direction.PAY_OUT, 'badge__brand': deal.type === _ctx.Direction.PAY_IN}])
                                  }, _toDisplayString(_ctx.$t(`direction.${deal.type}`)), 3)
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(deal.publicId), 1),
                                  _cache[4] || (_cache[4] = _createTextVNode()),
                                  _createVNode(_component_copy_button, {
                                    value: deal.publicId
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.dateHelper.format(deal.createdAt)), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t(`deal_status.${deal.status}`)), 1),
                                  (deal.isDisputeAutocompletingSuspend)
                                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                                        key: 0,
                                        class: "icon icon__warning icon__small d-flex",
                                        icon: "pause"
                                      }))
                                    : _createCommentVNode("", true),
                                  ([_ctx.DealStatus.NEW, _ctx.DealStatus.TRANSFER_CONFIRMED, _ctx.DealStatus.TRANSFER_WAITING].includes(deal.status))
                                    ? (_openBlock(), _createBlock(_component_PaymentTime, {
                                        key: 1,
                                        value: _ctx.getFormattedCancelTime(deal)
                                      }, null, 8, ["value"]))
                                    : (deal.disputeAutocloseAt && _ctx.DealStatus.DISPUTE === deal.status)
                                      ? (_openBlock(), _createBlock(_component_PaymentTime, {
                                          key: 2,
                                          value: _ctx.getFormattedDisputeAutocloseTime(deal)
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true),
                                  (deal.disputeAttachment)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 3,
                                        href: `${_ctx.api.baseUrl()}/attachments/${deal.disputeAttachment}`,
                                        target: "_blank"
                                      }, [
                                        _createVNode(_component_SvgIcon, {
                                          class: "icon icon__warning icon__small",
                                          icon: "paperclip"
                                        })
                                      ], 8, _hoisted_32))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deal.attachments, (attachment) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: attachment.id
                                    }, [
                                      _createElementVNode("a", {
                                        href: `${_ctx.api.baseUrl()}/attachments/${attachment.file}`,
                                        target: "_blank"
                                      }, [
                                        _createVNode(_component_SvgIcon, {
                                          class: "icon icon__warning icon__small",
                                          icon: "paperclip"
                                        })
                                      ], 8, _hoisted_33),
                                      _createVNode(_component_ReceiptCheckControl, {
                                        deal: deal,
                                        attachment: attachment
                                      }, null, 8, ["deal", "attachment"])
                                    ], 64))
                                  }), 128))
                                ]),
                                (deal.disputeReason === _ctx.DisputeReason.INVALID_SUM || deal.disputeReason === _ctx.DisputeReason.PART_PAYOUT)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_34, [
                                      _cache[5] || (_cache[5] = _createTextVNode(" (")),
                                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t(`dispute_reason.${deal.disputeReason}`)), 1),
                                      _createTextVNode(": " + _toDisplayString(_ctx.numberFormatter.formatNumber(deal.disputeReasonData.amount, 2)) + " " + _toDisplayString(deal.takerSum.currency) + ") ", 1)
                                    ]))
                                  : (_ctx.isPayOutReceiptCheck(deal.type, deal.disputeReason))
                                    ? (_openBlock(), _createBlock(_component_ReceiptCheckStatus, {
                                        key: 1,
                                        reason: deal.disputeReason,
                                        data: deal.disputeReasonData
                                      }, null, 8, ["reason", "data"]))
                                    : (deal.disputeReason)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_36, " (" + _toDisplayString(_ctx.$t(`dispute_reason.${deal.disputeReason}`)) + ") ", 1))
                                      : _createCommentVNode("", true),
                                (deal.transactionId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _createElementVNode("small", _hoisted_38, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('labels.transaction')) + ": ", 1),
                                        _withDirectives((_openBlock(), _createElementBlock("span", {
                                          title: deal.transactionId
                                        }, [
                                          _createTextVNode(_toDisplayString(deal.transactionId.length > 8 ? deal.transactionId.substring(0, 4) + '...' + deal.transactionId.substring(deal.transactionId.length - 4) : deal.transactionId), 1)
                                        ], 8, _hoisted_39)), [
                                          [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            { hover: true }
                                          ]
                                        ]),
                                        _cache[6] || (_cache[6] = _createTextVNode()),
                                        _createVNode(_component_copy_button, {
                                          value: deal.transactionId
                                        }, null, 8, ["value"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.dateHelper.format(deal.updatedAt)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_41, [
                            ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.store.getters.getAccountCurrencies.includes(deal.takerSum.currency))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.rateHeader), 1)
                                  ]),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(deal.takerSum.amount / deal.makerSum.amount, deal.takerSum.subunit)) + " " + _toDisplayString(deal.takerSum.currency), 1),
                                  (deal.merchantMakerSum)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, " / " + _toDisplayString(_ctx.numberFormatter.formatNumber(deal.takerSum.amount / deal.merchantMakerSum.amount, deal.takerSum.subunit)) + " " + _toDisplayString(deal.takerSum.currency), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.isEffectiveRateEnabled && deal.rewardSum)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, " / " + _toDisplayString(_ctx.numberFormatter.formatNumber((deal.takerSum.amount / deal.makerSum.amount) * (1 + deal.rewardSum?.amount / deal.makerSum.amount), deal.takerSum.subunit)) + " " + _toDisplayString(deal.takerSum.currency), 1))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _createElementVNode("td", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('labels.sum')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              (deal.actualTakerSum)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.actualTakerSum)) + " ", 1),
                                      _createVNode(_component_copy_button, {
                                        value: deal.actualTakerSum.amount
                                      }, null, 8, ["value"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (!deal.actualTakerSum || deal.isActualSumsChanged)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["reception__sum-rub sum-info__rub", {'text-decoration-line-through': deal.isActualSumsChanged}])
                                  }, [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.takerSum)) + " ", 1),
                                      _createVNode(_component_copy_button, {
                                        value: deal.takerSum.amount
                                      }, null, 8, ["value"])
                                    ])
                                  ], 2))
                                : _createCommentVNode("", true),
                              ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.store.getters.getAccountCurrencies.includes(deal.takerSum.currency))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55))
                                : (deal.actualMakerSum)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.actualMakerSum)) + " ", 1),
                                        _createVNode(_component_copy_button, {
                                          value: deal.actualMakerSum.amount
                                        }, null, 8, ["value"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                              ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.store.getters.getAccountCurrencies.includes(deal.takerSum.currency))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58))
                                : (!deal.actualMakerSum || deal.isActualSumsChanged)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 5,
                                      class: _normalizeClass(["reception__sum-currency sum-info__currency", {'text-decoration-line-through': deal.isActualSumsChanged}])
                                    }, [
                                      _createElementVNode("div", _hoisted_59, [
                                        _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.makerSum)) + " ", 1),
                                        _createVNode(_component_copy_button, {
                                          value: deal.makerSum.amount
                                        }, null, 8, ["value"])
                                      ])
                                    ], 2))
                                  : _createCommentVNode("", true),
                              ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.store.getters.getAccountCurrencies.includes(deal.takerSum.currency))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_60))
                                : (deal.minTakerSum && deal.maxTakerSum)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                      (deal.minTakerSum?.amount !== deal.maxTakerSum?.amount)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_62, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minTakerSum)) + " - " + _toDisplayString(_ctx.numberFormatter.formatMoney(deal.maxTakerSum)), 1))
                                        : (_openBlock(), _createElementBlock("small", _hoisted_63, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minTakerSum)), 1))
                                    ]))
                                  : ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.store.getters.getAccountCurrencies.includes(deal.takerSum.currency))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                                    : _createCommentVNode("", true),
                              (deal.minInTakerSum && deal.maxInTakerSum)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    (deal.minInTakerSum?.amount !== deal.maxInTakerSum?.amount)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_66, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minInTakerSum)) + " - " + _toDisplayString(_ctx.numberFormatter.formatMoney(deal.maxInTakerSum)), 1))
                                      : (_openBlock(), _createElementBlock("small", _hoisted_67, _toDisplayString(_ctx.numberFormatter.formatMoney(deal.minInTakerSum)), 1))
                                  ]))
                                : _createCommentVNode("", true),
                              (deal.strictlySingleTransfer === true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                    _createVNode(_component_svg_icon, {
                                      class: "icon icon__warning icon__small",
                                      icon: "warning"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.strictly_single_transfer')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (deal.payOutReceiptsHint)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.$t('labels.pay_out_receipts_hint_card')) + ": " + _toDisplayString(deal.payOutReceiptsHint), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_70, [
                            (deal.type === _ctx.Direction.PAY_IN)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t('labels.device')), 1)
                                  ]),
                                  (deal._device)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                                        _createElementVNode("img", {
                                          src: require(`@/apps/public/assets/img/device-${deal._device.status}.svg`)
                                        }, null, 8, _hoisted_75),
                                        _createTextVNode(" " + _toDisplayString(deal._device?.name), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                  _createVNode(_component_PayMethodIcon, {
                                    "icon-class": "pay-method-icon-xl",
                                    method: deal.paymentMethod
                                  }, null, 8, ["method"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("span", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`payment_options.${deal.paymentOption}`)) + " ", 1),
                                      (deal.requisites?.crossBorderCurrency)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(deal.requisites?.crossBorderCurrency), 1))
                                        : _createCommentVNode("", true),
                                      _cache[7] || (_cache[7] = _createTextVNode()),
                                      (deal.requisites?.paymentSystem)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.$t('payment_systems.' + deal.requisites?.paymentSystem)), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_83, [
                                    (deal.type === _ctx.Direction.PAY_OUT && deal.status === _ctx.DealStatus.NEW)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                                          _createElementVNode("small", _hoisted_85, _toDisplayString(_ctx.$t('labels.accept_deal_to_show_req')), 1)
                                        ]))
                                      : (deal.type === _ctx.Direction.PAY_OUT && deal.payoutQr?.link)
                                        ? (_openBlock(), _createBlock(_component_PayoutQrBlock, {
                                            key: 1,
                                            link: deal.payoutQr.link,
                                            compact: true
                                          }, null, 8, ["link"]))
                                        : (_ctx.helper.isEmvQrOption(deal.paymentOption))
                                          ? (_openBlock(), _createBlock(_component_VietQrPaymentBlock, {
                                              key: 2,
                                              "deal-id": deal.id,
                                              "hide-qr": true,
                                              "qr-code-data": deal.qrCodeData ?? null,
                                              "qr-code-link": _ctx.helper.emvQrData(deal),
                                              "fallback-requisites": deal.paymentRequisites.requisites || ''
                                            }, null, 8, ["deal-id", "qr-code-data", "qr-code-link", "fallback-requisites"]))
                                          : (deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(deal))
                                            ? (_openBlock(), _createBlock(_component_VietQrPaymentBlock, {
                                                key: 3,
                                                "deal-id": deal.id,
                                                "hide-qr": true,
                                                "qr-code-data": null,
                                                "qr-code-link": _ctx.helper.dealQrCodeLink(deal),
                                                "fallback-requisites": ''
                                              }, null, 8, ["deal-id", "qr-code-link"]))
                                            : (deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_86, _toDisplayString(_ctx.$t('labels.manual_sbp_qr_awaiting_link')), 1))
                                              : (deal.paymentOption === _ctx.PaymentOption.SBP_QR && deal.paymentRequisites.requisites?.startsWith('http'))
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 5,
                                                    href: deal.paymentRequisites.requisites,
                                                    target: "_blank"
                                                  }, _toDisplayString(_ctx.helper.domain(deal.paymentRequisites.requisites)), 9, _hoisted_87))
                                                : (deal.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && deal.paymentRequisites.requisites?.startsWith('http'))
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 6,
                                                      href: deal.paymentRequisites.requisites,
                                                      target: "_blank"
                                                    }, _toDisplayString(_ctx.$t('labels.my_click_uz')), 9, _hoisted_88))
                                                  : (deal.paymentOption === _ctx.PaymentOption.TIPS && deal.paymentRequisites.requisites?.startsWith('http'))
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 7,
                                                        href: deal.paymentRequisites.requisites,
                                                        target: "_blank"
                                                      }, _toDisplayString(_ctx.helper.domain(deal.paymentRequisites.requisites)), 9, _hoisted_89))
                                                    : (deal.paymentRequisites.requisites?.startsWith('http'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                          _createElementVNode("a", {
                                                            href: deal.paymentRequisites.requisites,
                                                            target: "_blank"
                                                          }, _toDisplayString(_ctx.helper.domain(deal.paymentRequisites.requisites)), 9, _hoisted_91),
                                                          _cache[8] || (_cache[8] = _createTextVNode()),
                                                          _createVNode(_component_copy_button, {
                                                            value: deal.paymentRequisites.requisites
                                                          }, null, 8, ["value"])
                                                        ]))
                                                      : (deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM || (deal.type === _ctx.Direction.PAY_OUT && deal.paymentOption === _ctx.PaymentOption.TO_CARD))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                                            _createTextVNode(_toDisplayString(deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim()) + " ", 1),
                                                            _createVNode(_component_copy_button, {
                                                              value: deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim()
                                                            }, null, 8, ["value"])
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                            _createTextVNode(_toDisplayString(deal.paymentRequisites.requisites) + " ", 1),
                                                            _createVNode(_component_copy_button, {
                                                              value: deal.paymentRequisites.requisites
                                                            }, null, 8, ["value"])
                                                          ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_94, [
                                    (deal.paymentOption === _ctx.PaymentOption.SBP_QR && deal.requisites && !deal.requisites.requisites.startsWith('http'))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(deal.requisites.requisites), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", null, _toDisplayString(deal.paymentRequisites.holder), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_96, [
                            (deal.type === _ctx.Direction.PAY_OUT )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                  _createElementVNode("button", {
                                    onClick: [
                                      _withModifiers(($event: any) => (_ctx.showDealDetails(deal)), ["prevent"]),
                                      _cache[0] || (_cache[0] = () => {})
                                    ],
                                    type: "button",
                                    class: "btn"
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "details" })
                                  ], 8, _hoisted_98),
                                  (deal.status === _ctx.DealStatus.TRANSFER_WAITING || deal.status === _ctx.DealStatus.DISPUTE)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (_ctx.refuseDeal(deal)), ["prevent"]),
                                        class: "btn btn--reset"
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "cancel" })
                                      ], 8, _hoisted_99))
                                    : _createCommentVNode("", true),
                                  (_ctx.hasPayOutDealSla(deal))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        onClick: _withModifiers(($event: any) => (_ctx.showPayOutDealSla(deal)), ["prevent"]),
                                        type: "button",
                                        class: "btn no-wrap"
                                      }, [
                                        _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t('button.sla')), 1)
                                      ], 8, _hoisted_100))
                                    : _createCommentVNode("", true),
                                  (deal.status === _ctx.DealStatus.NEW && !_ctx.isExpired(deal))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        onClick: _withModifiers(($event: any) => (_ctx.acceptDeal(deal)), ["prevent"]),
                                        class: "btn btn--accept no-wrap"
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "clock" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getFormattedCancelTime(deal)) + " ", 1),
                                        _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t('button.accept')), 1)
                                      ], 8, _hoisted_102))
                                    : _createCommentVNode("", true),
                                  (_ctx.user.isPayoutConfirmationFromWebAppAllowed && (deal.status === _ctx.DealStatus.TRANSFER_WAITING || deal.status === _ctx.DealStatus.DISPUTE))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 3,
                                        onClick: _withModifiers(($event: any) => (_ctx.confirmPayoutDeal(deal)), ["prevent"]),
                                        type: "button",
                                        class: "btn btn--accept"
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "check-small" })
                                      ], 8, _hoisted_104))
                                    : _createCommentVNode("", true),
                                  (deal.isVideoRequestAvailable)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 4,
                                        onClick: _withModifiers(($event: any) => (_ctx.requestVideo(deal)), ["prevent"]),
                                        disabled: _ctx.isVideoRequested(deal),
                                        title: _ctx.isVideoRequested(deal) ? _ctx.dateHelper.format(deal.videoRequestedUntil) : null,
                                        type: "button",
                                        class: "btn no-wrap"
                                      }, [
                                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.isVideoRequested(deal) ? _ctx.$t('button.video_requested') : _ctx.$t('button.request_video')), 1)
                                      ], 8, _hoisted_105))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (deal.type === _ctx.Direction.PAY_IN )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                  _createElementVNode("button", {
                                    onClick: _withModifiers(($event: any) => (_ctx.showDealDetails(deal)), ["prevent"]),
                                    type: "button",
                                    class: "btn"
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "details" })
                                  ], 8, _hoisted_108),
                                  ([_ctx.DealStatus.DISPUTE, _ctx.DealStatus.TRANSFER_CONFIRMED, _ctx.DealStatus.TRANSFER_WAITING, _ctx.DealStatus.CANCELED].includes(deal.status))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (_ctx.confirmDeal(deal)), ["prevent"]),
                                        type: "button",
                                        class: "btn btn--accept"
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "check-small" })
                                      ], 8, _hoisted_109))
                                    : _createCommentVNode("", true),
                                  (deal.isVideoRequestAvailable)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        onClick: _withModifiers(($event: any) => (_ctx.requestVideo(deal)), ["prevent"]),
                                        disabled: _ctx.isVideoRequested(deal),
                                        title: _ctx.isVideoRequested(deal) ? _ctx.dateHelper.format(deal.videoRequestedUntil) : null,
                                        type: "button",
                                        class: "btn no-wrap"
                                      }, [
                                        _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.isVideoRequested(deal) ? _ctx.$t('button.video_requested') : _ctx.$t('button.request_video')), 1)
                                      ], 8, _hoisted_110))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 256))
                    ])
                  ])
                ]),
                (_ctx.deals.totalCount > _ctx.deals.items.length)
                  ? (_openBlock(), _createBlock(_component_b_pagination, {
                      key: 0,
                      modelValue: _ctx.page,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.load()))
                      ],
                      "total-rows": _ctx.deals.totalCount,
                      "per-page": _ctx.deals.limit,
                      limit: 20,
                      "prev-text": _ctx.$t('button.back'),
                      "next-text": _ctx.$t('button.next'),
                      align: "start",
                      "first-number": "",
                      "hide-goto-end-buttons": "",
                      "hide-ellipsis": ""
                    }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_DealDetailsPopup, { ref: "dealDetailsPopup" }, null, 512),
    _createVNode(_component_CancelReasonPopup, { ref: "cancelReasonPopup" }, null, 512),
    _createVNode(_component_ConfirmPopup, { ref: "confirmPopup" }, null, 512),
    _createVNode(_component_ConfirmPayoutPopup, { ref: "confirmPayoutPopup" }, null, 512),
    _createVNode(_component_PayOutDealSlaPopup, { ref: "payOutDealSlaPopup" }, null, 512)
  ], 64))
}